<template>
  <div class="md:hidden">
    <div class="fixed top-0 h-full w-full flex z-40 transition-all inset-0" :class="[isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none']">
      <!-- // :class="{'left-0 right-auto md:left-64 opacity-100' : isOpen, '-left-full md:left-0 opacity-50' : !isOpen}" -->

      <div class="fixed inset-0" :class="{
            'transition-opacity ease-linear duration-300': true,
            'opacity-0': !isOpen,
            'opacity-100': isOpen,
          }">
        <div class="absolute inset-0 bg-oakwood-gray-600 opacity-75"></div>
            
      </div>

      <div class="relative flex-1 flex flex-col max-w-xs w-full bg-bhav-blue-500" :class="{
          'transition ease-in-out duration-300 transform': true,
          '-translate-x-full': !isOpen,
          'translate-x-0': isOpen,
        }">
        <div class="absolute top-0 right-0 -mr-14 p-1">
          <button class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-oakwood-gray-600" aria-label="Close sidebar" @click="toggleSidebar">
            <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
          <div class="flex-shrink-0 flex items-center px-4">
            <img class="w-full" src="@/assets/images/oakwood-homes-logo.svg" alt="Oakwood Homes logo">
          </div>
          <nav class="mt-5 px-2 space-y-1">
            <router-link v-for="link,i in routes" :to="{name: link.name}" :key="`m-m-${i}`" class="group flex items-center px-2 py-2 text-sm leading-4 rounded-md focus:outline-none focus:bg-bhav-blue-700 transition ease-in-out duration-150" :class="link.name === this.$route.name || link.name === this.$route?.meta?.parent ? 'bg-white text-bhav-blue-500' : 'text-bhav-blue-300 hover:text-white'">
              <span class="mr-4 text-lg text-bhav-blue-400 group-hover:text-white group-focus:text-white transition ease-in-out duration-150 fak" :class="{[link.meta.icon] : true, 'group-hover:text-white' : link.name !== this.$route.name && link.name !== this.$route?.meta?.parent, 'text-bhav-blue-500': link.name === this.$route.name || link.name === this.$route?.meta?.parent, 'text-bhav-blue-300': link.name !== this.$route.name && link.name !== this.$route?.meta?.parent}"></span>
              {{ link.meta.title }}
            </router-link>
          </nav>
        </div>
        <div class="flex-shrink-0 flex border-t border-bhav-blue-600 p-4">
          <div class="flex items-center w-full">
            <div class="rounded-full overflow-hidden flex items-center justify-center bg-bhav-blue-400 text-white h-10 w-10">
              <img v-if="user?.image ?? false" class="aspect-square object-cover"
                :src="user.image" :alt="user.name">
              <i v-else class="fas fa-user"></i>
            </div>
            <div class="ml-3 flex-1">
              <p class="text-base leading-6 font-medium text-white">
                {{ user.name }}
              </p>
              <router-link :to="{name: 'profile-tab', params: {tab: 'edit'}}" class="text-sm leading-5 font-medium text-bhav-blue-400 group-hover:text-bhav-blue-200 transition ease-in-out duration-150">
                Profile Settings
              </router-link>
            </div>
            <div class="flex-0">            
              <p @click.prevent="toggleAlerts()" class="group flex items-center p-3 text-sm leading-5 font-medium rounded-md hover:text-white focus:outline-none transition ease-in-out duration-150 text-bhav-blue-300 hover:bg-bhav-blue-600 focus:bg-bhav-blue-600 cursor-pointer relative">
                <span class="text-xl text-bhav-blue-400  group-focus:text-bhav-blue-200 transition ease-in-out duration-150 fak fa-notification group-hover:text-bhav-blue-200"></span>
                <span v-if="count > 0" class="absolute bg-oakwood-red-600 text-white text-[.5rem] leading-none p-1 min-w-4 text-center rounded-lg top-0 right-2">{{ count }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-shrink-0 w-14">
        <!-- Force sidebar to shrink to fit close icon -->
      </div>
    </div>
  </div>


  <!-- Static sidebar for desktop -->
  <div class="hidden md:flex md:flex-shrink-0 z-40 relative">
    <div class="flex flex-col w-64">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex flex-col h-0 flex-1 bg-bhav-blue-500">
        <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
          <div class="flex items-center flex-shrink-0 px-4">
            <img class="w-full" src="@/assets/images/oakwood-homes-logo.svg" alt="">
          </div>
          <nav class="mt-5 flex-1 px-2 bg-bhav-blue-500 space-y-1">
            <router-link v-for="link,i in routes" :to="{name: link.name}" :key="`m-d-${i}`" class="group font-sans font-medium flex items-center p-3 text-sm leading-5 rounded-md focus:outline-none transition ease-in-out duration-150"
              :class="link.name === this.$route.name || link.name === this.$route?.meta?.parent ? 'bg-white text-bhav-blue-500' : 'text-bhav-blue-300 hover:bg-bhav-blue-400 hover:text-white focus:bg-bhav-blue-700'">
              <span class="mr-3 text-xl transition ease-in-out duration-150 fak" :class="{[link.meta.icon] : true, 'group-hover:text-white' : link.name !== this.$route.name && link.name !== this.$route?.meta?.parent, 'text-bhav-blue-500': link.name === this.$route.name || link.name === this.$route?.meta?.parent, 'text-bhav-blue-300': link.name !== this.$route.name && link.name !== this.$route?.meta?.parent}"></span>
              {{ link.meta.title }}
            </router-link>
          </nav>
        </div>
        <div class="flex-shrink-0 flex border-t border-bhav-blue-600 p-4">
          <div class="flex items-center w-full">
            <div class="rounded-full overflow-hidden flex items-center justify-center bg-bhav-blue-400 text-white h-10 w-10">
              <img v-if="user?.image ?? false" class="aspect-square object-cover"
                :src="user.image" :alt="user.name">
              <i v-else class="fas fa-user"></i>
            </div>
            <div class="ml-3 flex-1">
              <p class="text-sm leading-5 font-medium text-white">
                {{ user.name }}
              </p>
              <router-link :to="{name: 'profile-tab', params: {tab: 'edit'}}" class="text-xs leading-4 font-medium text-bhav-blue-300 group-hover:text-bhav-blue-100 transition ease-in-out duration-150">
                Profile Settings
              </router-link>
            </div>
            <div class="flex-0">            
              <p @click.prevent="toggleAlerts()" class="group flex items-center p-3 text-sm leading-5 font-medium rounded-md hover:text-white focus:outline-none transition ease-in-out duration-150 text-bhav-blue-400 hover:bg-bhav-blue-600 focus:bg-bhav-blue-700 cursor-pointer relative">
                <span class="text-xl text-bhav-blue-400  group-focus:text-bhav-blue-200 transition ease-in-out duration-150 fak fa-notification group-hover:text-bhav-blue-300"></span>
                <span v-if="count > 0" class="absolute bg-oakwood-red-600 text-white text-[.5rem] leading-none p-1 min-w-4 text-center rounded-lg top-0 right-2">{{ count }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Alert View Component -->
  <AlertView :isVisible="showAlerts" @close="closeAlerts" @ready="updateCount" />
</template>

<script>
  import { useAuthStore } from '@/stores/auth';
  import { mapActions, mapState } from 'pinia';
  import AlertView from './AlertView.vue';
  export default {
    name: "MenuNavigation",
    components: {
      AlertView,
    },
    props: ["isOpen"],
    setup() {
      return {}
    },
    data() {
      return {
        showAlerts: false,
        count: 0
      }
    },

    methods: {
      toggleSidebar() {
        this.$emit("update:isOpen", !this.isOpen);
      },
      closeAlerts() {
        this.showAlerts = false;
      },
      toggleAlerts() {
        if(this.isOpen && !this.showAlerts) this.toggleSidebar();
        this.showAlerts = !this.showAlerts;
      },
      updateCount(count) {
        this.count = count
      }
    },
    computed: {
      ...mapState(useAuthStore, ['user']),
      routes() {
        return this.$router.getRoutes()
          .filter(route => {
            return route?.meta?.menu === true && this.user.level >= route.meta.acl
          })
          .sort((a,b) => a.meta?.order > b.meta?.order ? 1 : -1);
      }
    },
    watch: {
      '$route' : {
        handler() {
          this.$emit("update:isOpen", false);
        },
        deep: true
      }
    }
  }
</script>
